export const state = {
  accounttypes: [],
  systemAccounttype: [],
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/accounttypes/state.js